module.exports = __webpack_public_path__ + "img/组 131@2x.60266144.png";